<template lang="pug">
  div
    page-preloader
    div.map-container.navigation-control.routes
      auto-route(
        :msnsByLocations="msnsByLocations"
        :tkoObjects="tkoObjects"
        ref="autoRoute"
        style="position: relative;z-index: 9999;height:100%;"
        @routesGenerated="routesGenerated"
      )
      
      div.toolbar.toolbar--bordered
        div.line
          h1.title Карта
      
      div.new-map
        div(ref="map" v-once)#map.bigmap
        transition(name="slide-fade")
          div(
            v-if="openedRoute && openedRoute.id"
            :style="{width: '537px !important'}"
          ).legend.map-routes.cuscroll.open
            div
              div.head
                h2.title Изменение маршрута
                div.legend-info
                span.legend__close(@click="closeRoute()")
              
              div.type-group
                div.route-info
                  div.route-info-line.flex-col
                    label Номер маршрута
                    input(v-model="openedRoute.name" type="text")
              
              div.type-group
                div.route-info
                  div.route-info-line
                    label Протяженность (км):
                    span {{openedRoute.distance}}
                  div.route-info-line
                    label Приблизительное время:
                    span {{openedRoute.duration}}
                  div.route-info-line
                    label Стоимость:
                    span {{openedRoute.cost}}
                  div.route-info-line
                    label Масса:
                      input.radio(
                        value="5"
                        v-model="openedRoute.mass"
                        name="mass"
                      )
              
              div.type-group
                div.route-info.schedule
                  div.route-info-line
                    label Периодичность маршрута
                  
                  div.route-info-line.flex
                    .route-info-line__block
                      e-radio(
                        name="period_id"
                        :options="routePeriods"
                        :model="openedRoute"
                        tabView="tab1"
                      ).periodicity
                    .route-info-line__block
                      template(v-if="openedRoute.period_id === PERIOD_WEEKLY")
                        div.week
                          p День недели
                          label.radioButton
                            input.radio(
                              value="1"
                              v-model="openedRoute.weekday_id"
                              type="radio"
                              name="weekday_id"
                            )
                            span Пн
                          label.radioButton
                            input.radio(
                              value="2"
                              v-model="openedRoute.weekday_id"
                              type="radio"
                              name="weekday_id"
                            )
                            span Вт
                          label.radioButton
                            input.radio(
                              value="3"
                              v-model="openedRoute.weekday_id"
                              type="radio"
                              name="weekday_id"
                            )
                            span Ср
                        div.week
                          label.radioButton
                            input.radio(
                              value="4"
                              v-model="openedRoute.weekday_id"
                              type="radio"
                              name="weekday_id"
                            )
                            span Чт
                          label.radioButton
                            input.radio(
                              value="5"
                              v-model="openedRoute.weekday_id"
                              type="radio"
                              name="weekday_id"
                            )
                            span Пт
                          label.radioButton
                            input.radio(
                              value="6"
                              v-model="openedRoute.weekday_id"
                              type="radio"
                              name="weekday_id"
                            )
                            span Сб
                        div.week
                          label.radioButton
                            input.radio(
                              value="7"
                              v-model="openedRoute.weekday_id"
                              type="radio"
                              name="weekday_id"
                            )
                            span Вс
              
              div(:style="{padding: '0.7rem'}").type-group.type-group--small-pad
                div.col
                  e-form(:formValidator="formValidator")
                    e-form-group(
                      :formGroupStyle="'col-block mt-4'"
                      :inputStyle="{width: '94%', 'margin-top': '3%', display: 'block'}"
                      name="start_point_address"
                      inputType="address"
                      label="Начальная точка"
                      :model="openedRoute"
                      tabView="tab1"
                      :required="true"
                      :addressData="addressData"
                      :addressProvider="'dadata'"
                      @selectItem="onSelectAddress"
                    )
                    
                    e-form-group(
                      name="end_point_id"
                      :inputStyle="{width: '94%', 'margin-top': '3%', display: 'block'}"
                      inputType="select"
                      label="Место размещения отхода"
                      :model="openedRoute"
                      tabView="tab1"
                      :required="true"
                      :options="tkoObjects"
                      @change="onChangeAddressTkoObject"
                    )
                  div.control-panel
                    div(v-if="waitForPoint === false")
                      button(@click.stop.prevent="addPoint").actions-panel__button.btn-add.btn-green.small
                      span Добавить адреса
                    div(v-if="waitForPoint === true")
                      button(@click.stop.prevent="" :disabled="true").actions-panel__button.btn-add.btn-grey.small
                      span Добавить адреса
                    div(v-if="calcEnable===true")
                      button(@click.stop.prevent="calcRoute").actions-panel__button.btn-calc.btn-blue.small
                      span Рассчитать маршрут
                    div(v-if="saving===false && saveEnable===true")
                      button(@click.stop.prevent="saveRoute").actions-panel__button.btn-save.btn-blue.small
                      span Сохранить
                    div(v-else-if="saving===true")
                      button(@click.stop.prevent="").actions-panel__button.btn-refresh.btn-btn-yellow.small
                      span Сохранение...
              e-perfect-scrollbar(
                ref="points"
                :styles="{padding: '1rem', height: '20vh'}"
              )
                div.type-group.type-group--noborder.route-table
                  table
                    thead
                      th №
                      th Адрес
                      th Количество
                      th Объем куб.м.
                      th
                    tbody(
                      v-if="openedRoute.startPoint && openedRoute.start_point_address"
                    )
                      tr(
                        class="hovered"
                        title="Начальная точка - гараж"
                        @click="zoomToPoint(openedRoute.startPoint)"
                      )
                        td
                          img(:src="GarageImage" style="width:20px")
                        td {{openedRoute.start_point_address}}
                        td -
                        td -
                        td -
                    tbody(
                      v-if="Object.keys(routeMsns).length"
                      is="transition-group"
                      name="flip-list"
                    )
                      tr(
                        class="hovered"
                        v-for="(point, index) in routePointList"
                        :key="index"
                        @click="zoomToPoint(point)"
                      )
                        td(align="center") {{(index + 1)}}
                        td {{point.streetWithNumber || point.address}}
                        td {{point.containers_count || ' - '}}
                        td {{point.containersVolumeSum || ' - '}}
                        td
                          span(
                            @click.stop.prevent="removePoint(index)"
                          ).close--small
                    tbody(v-else)
                      tr
                        td(colspan=100) нет адресов контейнерных площадок
                    
                    tbody(
                      v-if="openedRoute.endPoint && openedRoute.endPoint.address"
                    )
                      tr(
                        class="hovered"
                        title="Конечная точка - объект размещения отходов"
                        @click="zoomToPoint(openedRoute.endPoint)"
                      )
                        td
                          img(:src="OROImage" style="width:20px")
                        td {{openedRoute.endPoint.address}}
                        td -
                        td -
                        td -
          div(
            v-else
            key="routes"
          ).legend.map-routes.cuscroll.open
            div
              div.head
                h2.title Маршруты
                div.legend-info
                span
              
              div.type-group.type-group--small-pad
              div(@click.stop.prevent="addRoute()").add-address
                button.actions-panel__button.btn-add.btn-green.small
                span Добавить маршрут
              div(@click.stop.prevent="removeAllRoutes()").add-address
                button.actions-panel__button.btn-delete.btn-red.small
                span Удалить все
              
              e-perfect-scrollbar(ref="routes")
                div.type-group.type-group--noborder.route
                  table
                    thead
                      th № Маршрута
                      th Периодичность
                      th Протяженость (км)
                      th
                    tbody(
                      is="transition-group"
                      name="flip-list"
                      v-if="items && items.data.length > 0"
                    )
                      tr(
                        :key="item.id"
                        v-for="item in items.data"
                        @click="openRoute(item.id)"
                      )
                        td {{item.name ? item.name : ''}}
                        td {{item.period ? item.period.name : ''}}
                        td {{item.distance}}
                        td
                          span(
                            @click.stop.prevent="removeRoute(item.id)"
                          ).close--small
                    tbody(v-else)
                      tr
                        td(colspan=100) нет маршрутов
            
            div.type-group.type-group--noborder.route-create
              button(
                v-if="SHOW_HIDDEN_FIELDS"
                @click.stop.prevent="removeAll()"
              ).route-create__button Удалить все
              button(
                @click.stop.prevent="$refs.autoRoute.open()"
              ).route-create__button Автосоставление маршрутов

</template>


<script>
  import 'leaflet'
  import { MAP, TILE_LAYER }                                                   from '@/config/map'
  import { POLYGON }                                                           from '@/config/polygon'
  import mapMixin                                                              from '../../mixins/map-mixin.js'
  import { map as mapEndpoints, msn, tko, transport }                          from '../../api/api-endpoints.js'
  import { NOTIFY, PERIOD_WEEKLY_ID, SHOW_HIDDEN_FIELDS, STATUS_ACTIVE, WALL } from '@/config/config'
  import userFriendlyEr                                                        from '../../utils/userFriendlyEr.js'
  import RoutesDrawer                                                          from './utils/RoutesDrawer'
  import autoRoute                                                             from './components/auto-route'
  import Route                                                                 from './models/Route'
  import GarageImage                                                           from '../../assets/img/pins/mps.png'
  import OROImage                                                              from '../../assets/img/pins/oro.png'
  import formBaseMixin
                                                                               from '../../components/form/form-base-mixin.js'
  import { core }                                                              from '@/api/api-endpoints'
  
  export default {
    name: 'appeals-map',
    data() {
      this.mapLayers = null
      this.map       = null
      return {
        saving:       false,
        saveEnable:   false,
        waitForPoint: false,
        calcEnable:   false,
        addressData:  {},
        openedRoute:  {
          cost:                0,
          mass:                0,
          start_point_address: '',
          startPoint:          {
            coords:  [],
            address: '',
            data:    null
          },
          endPoint:            {
            id:      null,
            coords:  [],
            address: '',
            data:    null
          }
        },
        routeMsns:    {}
      }
    },
    components: {
      autoRoute
    },
    mixins:     [mapMixin, formBaseMixin],
    computed:   {
      collections() {
        return this.$store.getters.readUrlEndpoint(this.getCollectionEndpoint()) || {}
      },
      conditions() {
        return {
          noStartPoint:             this.openedRoute && !this.openedRoute.startPoint.hasOwnProperty('coords'),
          noPointsAtAll:            Object.keys(this.routeMsns).length < 1,
          oneOrLessPoints:          Object.keys(this.routeMsns).length <= 1,
          onlyStartPoint:           this.openedRoute.startPoint && Object.keys(this.routeMsns).length < 1,
          onlyStartAndEndPoints:    this.openedRoute.startPoint &&
                                      (this.openedRoute.endPoint !== undefined && this.openedRoute.endPoint.hasOwnProperty('coords')),
          minimumTwoPointsSelected: Object.keys(this.routeMsns).length > 1,
          startPointAndAnother:     this.openedRoute.startPoint.hasOwnProperty('coords') && Object.keys(this.routeMsns).length === 1
        }
      },
      routePointList() {
        return Object.values(this.routeMsns)
      },
      isCalcEnabled() {
        let c = this.conditions
        return c.onlyStartAndEndPoints || c.startPointAndAnother || c.minimumTwoPointsSelected
      },
      isSaveEnabled() {
        let c = this.conditions
        return c.minimumTwoPointsSelected || c.startPointAndAnother || c.onlyStartAndEndPoints
      },
      SHOW_HIDDEN_FIELDS() {
        return SHOW_HIDDEN_FIELDS
      },
      GarageImage() {
        return GarageImage
      },
      OROImage() {
        return OROImage
      },
      /**
       * @return {number}
       */
      PERIOD_WEEKLY() {
        return PERIOD_WEEKLY_ID
      },
      PERIODS() {
        return PERIODS
      },
      routePeriods() {
        return this.collections.route_period
      },
      weekDays() {
        return this.collections.weekday
      },
      msnsByLocations() {
        let msnsByLocations = {}
        // groub by location
        let msns            = this.msns.data || this.msns
        if (msns) {
          msns.forEach(v => {
            if (v.address) {
              let addrComponents = v.address.split(',')
              let city           = addrComponents[0]
              if (!msnsByLocations[city]) {
                msnsByLocations[city] = {
                  id:    city,
                  name:  city,
                  items: []
                }
              }
              let streetComponents = addrComponents.length > 1
                ? [...addrComponents.slice(1)]
                : [addrComponents[0]]
              v.streetWithNumber   = streetComponents.join(',').trim()
              msnsByLocations[city].items.push(v)
            }
          })
        }
        let arr = []
        for (let k in msnsByLocations) {
          arr.push(msnsByLocations[k])
        }
        return arr
      },
      msns() {
        return this.$store.getters.readUrlEndpoint(this.getMSINAddresses())
      },
      STATUS_ACTIVE() {
        return STATUS_ACTIVE
      },
      mapBorders() {
        return this.$store.getters.readUrlEndpoint(
          mapEndpoints.heatMapRegOperators(this.$route.query.zoom || MAP.zoom)
        )
      },
      items() {
        return this.$store.getters.readUrlEndpoint(this.getItemsEndpoint())
      },
      tkoObjects() {
        return this.$store.getters.readUrlEndpoint(this.getTKOObjects()).data
      }
    },
    created() {
      this.markerClickSubs = this.$emitter.listen('marker.click', e => this.onMarkerClick(e))
    },
    destroyed() {
      this.markerClickSubs.unsubscribe()
    },
    methods: {
      getCollectionEndpoint() {
        return core.collection('route_period,weekday')
      },
      onSelectAddress({ data, value }) {
        this.$set(this.openedRoute, 'start_point_address', value)
        this.$set(this.openedRoute, 'startPoint', {
          coords: [
            +data.geo_lat,
            +data.geo_lon
          ],
          data
        })
        if (this.openedRoute.endPoint.coords.length < 1) {
          this.showMsg('Выберите место размещения отхода')
        }
        if (this.isCalcEnabled) {
          this.calcEnable = true
        }
      },
      onChangeAddressTkoObject() {
        this.tkoObjects.forEach(item => {
          if (item.id === this.openedRoute.end_point_id) {
            this.openedRoute.endPoint   = {
              id:      item.id,
              address: item.name,
              coords:  [
                +item.latitude,
                +item.longitude
              ]
            }
            this.openedRoute.endAddress = `${item.name}, ${item.address}`
            if (this.openedRoute.startPoint.coords.length < 1) {
              this.showMsg('Выберите начальную точку маршрута', 'success', 90000)
            }
          }
        })
        if (this.isCalcEnabled) {
          this.calcEnable = true
        }
      },
      calcRoute() {
        this.reCalcRoute().then(() => {
          this.waitForPoint              = false
          this.routesDrawer.waitForPoint = false
        })
      },
      zoomToPoint(point) {
        const { latitude, longitude, coords } = point
        if (latitude && longitude) {
          this.map.setView([latitude, longitude], 16)
        } else if (Array.isArray(coords)) {
          this.map.setView(coords, 16)
        }
      },
      scrollToBottom() {
        if (this.$refs.routes) {
          this.$refs.routes.setScrollTop(999999)
        } else if (this.$refs.points) {
          this.$refs.points.setScrollTop(999999)
        }
      },
      async routesGenerated(routes) {
        this.$bar.start()
        this.$refs.autoRoute.freeze()
        await this.batchCreateRoute(routes).then(async () => {
          await this.fetchData().then(() => {
            this.scrollToBottom()
            this.showOnSuccess('Новые маршруты сформированы')
          })
        }).catch(e => {
          console.error(e)
          this.onError(e)
        }).finally(() => {
          this.$bar.finish()
          this.$refs.autoRoute.close()
        })
      },
      async batchCreateRoute(routes) {
        let lastNumber = this.getNextRouteNumber()
        for (let i = 0; i < routes.length; i++) {
          let route  = await this.directions(routes[i])
          route.name = `${lastNumber}`
          for (let mIndex = 0; mIndex < route.msn.length; mIndex++) {
            route.msn[mIndex] = this.prepareMSNModel(route.msn[mIndex])
          }
          await this.$store.dispatch('createModel', {
            url:  transport.route(),
            data: route
          })
          lastNumber++
        }
        return true
      },
      removeRoute(id) {
        this.confirmBox(
          'Удаленный маршрут нельзя будет восстановить',
          'Удалить маршрут?'
        ).then(() => {
          this.$bar.start()
          this.$store.dispatch('deleteModel', {
            url: transport.route(id)
          }).then(() => {
            this.showOnSuccess('Маршрут удален')
            this.fetchData()
          }).catch(e => {
            console.error(e)
            this.onError(e)
          }).finally(() => {
            this.$bar.finish()
          })
        })
      },
      confirmBox(
        msg            = 'Удаленную запись нельзя будет восстановить',
        title          = 'Удалить запись?',
        confirmBtnText = 'Удалить'
      ) {
        return this.$confirm(msg, title, {
          confirmButtonText: confirmBtnText,
          cancelButtonText:  'Отмена',
          type:              'warning',
          closeOnClickModal: false
        })
      },
      removePoint(i) {
        const model  = this.routeMsns[i]
        const marker = model.marker ? model.marker : Object.values(this.routesDrawer._markers).find(m => model.id === m.options.model.id)
        if (!marker) {
          return
        }
        marker.setIcon(this.routesDrawer.markerCreator.createIconObject('places', 'container-gray'))
        this.$delete(this.routeMsns, i)
        if (Object.keys(this.routeMsns).length) {
          const msns     = Object.values(this.routeMsns)
          this.routeMsns = {}
          msns.forEach((v, i) => {
            this.$set(this.routeMsns, i, v)
          })
        }
        this.calcEnable = this.isCalcEnabled
        if (!this.calcEnable) {
          this.routesDrawer.removeRoute()
          this.showMsg('В маршруте необходимо указать минимум два пункта. Добавьте пункт(ы) или закройте панель изменения маршрута, чтобы отменить изменения', 'warning', NOTIFY.NOTIFY_TIMEOUT)
        }
        
        if (this.saveEnable) { //костыль
          this.saveEnable = false
        }
      },
      
      async saveRoute() {
        if (this.saving) {
          return
        }
        this.waitForPoint              = false
        this.routesDrawer.waitForPoint = false
        this.$bar.start()
        this.saving = true
        try {
          const data = Object.assign(
            {},
            this.openedRoute,
            { msns: this.routePointList.length ? this.routePointList.map(r => r.id) : [] }
          )
          await this.$store.dispatch('updateModel', {
            url:  transport.route(this.openedRoute.id),
            data: data
          })
          this.showOnSuccess('Маршрут сохранен')
          this.fetchData()
          
          this.saving = false
          this.$bar.finish()
        } catch (e) {
          console.error(e)
          this.onError(e)
        }
      },
      async reCalcRoute() {
        this.showWarning('Подождите, маршрут рассчитывается.')
        this.$bar.start()
        this.routesDrawer.removeRoute()
        let route = await this.directions(this.openedRoute)
        
        if (Object.keys(route).length > 0) {
          this.saveEnable  = this.isSaveEnabled
          this.calcEnable  = false
          this.openedRoute = Object.assign({}, this.openedRoute, route)
          await this.routesDrawer.drawRoute(this.openedRoute, this.msns, this.routeMsns)
          this.$bar.finish()
          this.showOnSuccess('Маршрут рассчитан.')
        } else {
          this.onError('Расчет не удался из-за ошибки. Попробуйте еще раз')
          this.calcEnable = true
        }
      },
      async putMSN(model) {
        const index = Object.keys(this.routeMsns).length
        await this.$set(this.routeMsns, index, model)
        this.calcEnable = this.isCalcEnabled
        if (this.calcEnable) {
          this.showMsg('Нажмите «Рассчитать маршрут»')
        }
      },
      redrawPoints() {
        this.$bar.start()
        this.routesDrawer.drawPoints(this.msns, this.routeMsns).then(() => {
          this.$bar.finish()
        })
      },
      async directions(inputOpenedRoute = {}) {
        let openedRoute      = JSON.parse(JSON.stringify(inputOpenedRoute))
        let latlngArr        = Object.values(this.routeMsns).map(v => `${v.latitude || v.lat},${v.longitude || v.lng}`)
        let startPointCoords = openedRoute.startPoint ? openedRoute.startPoint.coords : []
        let endPointCoords   = openedRoute.endPoint ? openedRoute.endPoint.coords : []
        let hasStartPoint    = (startPointCoords) && (startPointCoords.length > 1) && startPointCoords[0] && startPointCoords[1]
        let hasEndPoint      = (endPointCoords) && (endPointCoords.length > 1) && endPointCoords[0] && endPointCoords[1]
        
        let query         = {}
        query             = {
          origin:      hasStartPoint ? `${startPointCoords[0]},${startPointCoords[1]}` : latlngArr[0],
          destination: hasEndPoint ? `${endPointCoords[0]},${endPointCoords[1]}` : latlngArr[latlngArr.length - 1]
        }
        const queryString = []
        let ws            = latlngArr.slice()
        query.waypoints   = ws.join(';')
        if (query.origin) {
          queryString.push(query.origin)
        }
        if (query.waypoints && query.waypoints.length > 0) {
          queryString.push(query.waypoints)
        }
        if (query.destination) {
          queryString.push(query.destination)
        }
        
        await this.$store.dispatch('createModel', {
          url:  transport.directions,
          data: { coords: queryString.join(';') }
        }).then(r => {
          if (!r.data || !r.data.routes) {
            return
          }
          let polyline = []
          let distance = r.data.distance
          let duration = r.data.duration
          // create route
          
          r.data.routes.legs.forEach(leg => {
            distance = distance + (+leg.distance)
            duration = duration + (+leg.duration)
            leg.steps.forEach(step => {
              let decoded = step.geometry.coordinates
              decoded.forEach(point => {
                polyline.push(point)
              })
            })
          })
          openedRoute.polyline = polyline
          if (distance > 0) {
            openedRoute.distance = (distance / 1000).toFixed(3)
          }
          if (duration > 0) {
            let hours                 = Math.floor(duration / 60 / 60)
            let durInMin              = Math.round((duration / 60) - (60 * hours))
            openedRoute.durationInSec = duration
            openedRoute.duration      = `${hours} ч, ${durInMin} мин`
          }
          
        }).catch(e => {
          console.error(e)
          return Promise.reject(e)
        })
        return openedRoute
      },
      showMsg(msg, type = 'success', duration = WALL.SUCCESS_TIMEOUT) {
        this.msgSuccess = this.$message({
                                          message: msg,
                                          type:    type,
                                          duration
                                        })
      },
      onError(e) {
        this.$message({
                        message:  userFriendlyEr.recognize(e),
                        type:     'error',
                        duration: WALL.ERROR_TIMEOUT
                      })
      },
      showOnSuccess(title = 'Действие успешно завершено') {
        this.$swal({
                     position:          'center',
                     type:              'success',
                     title:             title,
                     showConfirmButton: false,
                     timer:             WALL.SUCCESS_TIMEOUT
                   })
      },
      showWarning(title = 'Пожалуйста, подождите!') {
        this.$swal({
                     position:          'center',
                     type:              'warning',
                     title:             title,
                     showConfirmButton: false,
                     timer:             WALL.SUCCESS_TIMEOUT
                   })
      },
      addPoint() {
        this.waitForPoint              = true
        this.routesDrawer.waitForPoint = true
        this.saveEnable                = false
        this.calcEnable                = this.isCalcEnabled
        if (this.calcEnable) {
          this.showMsg('Кликайте по серым маркерам, чтобы добавить новые адреса')
        }
      },
      async openRoute(id) {
        if (!this.items || !this.items.data || !this.items.data.length) {
          return
        }
        
        this.$store.commit('preloaderOn', true)
        this.$store.commit('preloader', true)
        
        this.saveEnable = false
        this.$bar.start()
        
        if (this.items && this.items.data && this.items.data.length) {
          const foundRoute        = this.items.data.find(r => r.id === id)
          const { msn, ...route } = foundRoute
          
          this.openedRoute = Object.assign({}, this.openedRoute, route)
          msn.forEach((m, i) => {
            this.$set(this.routeMsns, i, m)
          })
          setTimeout(async () => {
            this.routesDrawer.removeRoute()
            await this.routesDrawer.drawRoute(this.openedRoute, this.msns, this.routeMsns)
            this.prevPostiton = {
              zoom:   this.map.getZoom(),
              center: this.map.getCenter()
            }
            this.routesDrawer.zoomToRoute()
            this.$store.commit('preloaderOn', false)
            this.$store.commit('preloader', false)
          }, 500)
          this.$bar.finish()
        }
        if (this.conditions.noStartPoint) {
          this.showMsg('Выберите начальную точку маршрута')
        }
      },
      closeRoute() {
        if (this.prevPostiton && this.prevPostiton.zoom) {
          this.map.setView(
            this.prevPostiton.center,
            this.prevPostiton.zoom
          )
        }
        this.waitForPoint              = false
        this.routesDrawer.waitForPoint = false
        this.openedRoute               = Object.create(null)
        this.routesDrawer.removeAll()
        this.fetchData()
      },
      getNextRouteNumber() {
        let biggest = 0
        if (this.items && this.items.data && this.items.data.length) {
          biggest = 1
          this.items.data.forEach(v => {
            if (v.name && +v.name > 0) {
              biggest = +v.name
            }
          })
        }
        return biggest + 1
      },
      // create new route
      addRoute() {
        this.$bar.start()
        let route  = new Route()
        route.name = this.getNextRouteNumber()
        this.$store.dispatch('createModel', {
          url:  transport.route(),
          data: route
        }).then(r => {
          let { data: { id } } = r
          this.fetchData().then(() => {
            this.scrollToBottom()
            setTimeout(() => {
              this.openRoute(id)
            }, 500)
          })
        }).catch(e => {
          console.error(e)
          this.onError(e)
        }).finally(() => {
          this.$bar.finish()
        })
      },
      prepareMSNModel(model) {
        let containersVolumeSum = 0
        if (!model.hasOwnProperty('containers_count') && model.daily_norm) {
          model.containers_count = Math.round(model.daily_norm)
        }
        
        if (model.volume_count) {
          containersVolumeSum = (model.volume_count * 1).toFixed(3)
        } else if (model.containers_count) {
          containersVolumeSum = (model.containers_count * 0.75).toFixed(3)
        }
        if (isNaN(containersVolumeSum)) {
          containersVolumeSum = 0
        }
        model = { ...model, containersVolumeSum }
        return model
      },
      async onMarkerClick(evt) {
        if (!this.openedRoute || !this.openedRoute.id) {
          return
        }
        let { marker } = evt
        if (this.waitForPoint === true && this.routesDrawer.waitForPoint === true) {
          let model   = Object.assign({}, marker.options.model, {
            lat: marker.options.model.latitude,
            lng: marker.options.model.longitude,
            marker
          })
          const index = Object.values(this.routeMsns).findIndex(m => m.id === model.id)
          if (index === -1) {
            marker.setIcon(this.routesDrawer.markerCreator.createIconObject('places', 'container'))
            const msnModel = this.prepareMSNModel(model)
            await this.putMSN(msnModel)
            if (this.msgSuccess) {
              this.msgSuccess.close()
            }
          } else {
            this.removePoint(index)
          }
        }
      },
      getMapConfig(key) {
        return MAP[key]
      },
      getMapPolygon() {
        return POLYGON
      },
      drawTiles() {
        L.tileLayer(TILE_LAYER, {}).addTo(this.map)
      },
      afterMapInit() {
        this.routesDrawer = new RoutesDrawer(this.map, this)
      },
      /* required for use in map-poup.vue */
      popupIsOpened(markerInfo) {
        return false
      },
      /* required for use in map-poup.vue */
      registerOpenPopup(markerInfo) {
      },
      destroyMap() {
        console.log('destroyed')
        this.$emitter.emit('geo.destroyMap', {})
        // this.map.remove()
        this.map = null
      },
      getItemsEndpoint() {
        return transport.routes({
                                  query: {
                                    'per-page': -1
                                  }
                                })
      },
      getMSINAddresses() {
        return msn.addresses()
      },
      getTKOObjects() {
        return tko.objects({
                             query: { 'per-page': -1 }
                           }, '')
      },
      removeAllRoutes: async function() {
        this.$bar.start()
        try {
          if (this.items.data.length) {
            for (let i = 0; i < this.items.data.length; i++) {
              await this.$store.dispatch('deleteModel', {
                url:  transport.route(this.items.data[i].id),
                data: this.items.data[i]
              })
            }
            await this.fetchData()
          }
          this.showOnSuccess('Маршруты удалены')
        } catch (e) {
          console.error(e)
          alert(e.toString())
        } finally {
          this.$bar.finish()
        }
      },
      fetchData() {
        let { asyncData } = this.$options
        this.$bar.start()
        return asyncData({
                           store:   this.$store,
                           route:   this.$route,
                           methods: this
                         }).catch(e => {
          console.error(e)
        }).finally(() => {
          this.$bar.finish()
        })
      }
    },
    asyncData({ store, route, fromRoute, methods }) {
      let promises = []
      
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint:  methods.getCollectionEndpoint(),
        fromCache: true
      }))
      
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint:  mapEndpoints.heatMapRegOperators(route.query.zoom || MAP.zoom),
        fromCache: true
      }))
      
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getItemsEndpoint()
      }))
      
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint:  methods.getMSINAddresses(),
        fromCache: true
      }))
      
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getTKOObjects()
      }))
      
      if (promises.length === 0) {
        return Promise.resolve(1)
      }
      
      return Promise.all(promises)
    }
  }
</script>

<style type="scss" scoped>
  .control-panel {
    display: flex;
    margin-bottom: 15px;
  }
  
  .control-panel > div {
    margin: 10px;
  }
  
  .leaflet-routing-container {
    display: none;
  }
  
  .hovered:hover {
    cursor: pointer;
  }
  
  .route-table table {
    padding: 1px !important;
  }
  
  .body-wrapper {
    height: 11rem !important;
  }
  
  .main-layout .legend .head:hover {
    cursor: default;
  }
  
  .mt-4 {
    margin-top: 4%;
  }

</style>
